import { Card, Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import Gene20Box from "../../../Components/Gene20Box/Gene20Box";
import billBoardData from "./data";

export default function BillBoard() {
  const useStyles = makeStyles(() => ({
    root: {
      padding: "2vw",
    },
  }));
  const classes = useStyles();
  return (
    <Gene20Box className={classes.root}>
      <Grid container spacing={2}>
        {billBoardData.map((shop) => (
          <Grid item xs={4}>
            <Card sx={{overflow:"hidden"}}>
              <Typography>{shop.name}</Typography>
              <img height="50vh" src={shop.image}/>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Gene20Box>
  );
}
